import { useState, useEffect } from 'react';
import { Table, Button, Tag, Input, Image, Pagination, Cascader, Popconfirm, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { PlusSquareOutlined } from '@ant-design/icons';
import Https from '@/https';
import { DefaultOptionType } from 'antd/es/cascader';
import './DeviceType.css'

export default function DeviceType() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [messageApi, messageContextHolder] = message.useMessage();
  const [name, setName] = useState('');
  const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const [code, setCode] = useState('');
  const onCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCode(e.target.value);
  };

  const [deviceType, setDeviceType] = useState<string[]>([]);
  const [deviceTypeOptions, setDeviceTypeOptions] = useState<DefaultOptionType[]>([]);
  const getDeviceTypeOptions = () => {
    Https.post({
      url: 'Api/device/V1/deviceEnum/FindDeviceTypeEnumList',
      data: {}
    }).then((res) => {
      if(res.state === 1) {
        let list = res.data;
        setDeviceTypeOptions(list.map((item: any) => {
          return {
            value: item.value,
            label: item.text,
            children: item.children ? item.children.map((child: any) => {
              return {
                value: child.value,
                label: child.text
              }
            }) : []
          }
        }));
      }
    })
  }

  const [deviceFactoryList, setDeviceFactory] = useState<any[]>([]);
  const getDeviceFactoryList = () => {
    Https.post({
      url: 'Api/device/V1/deviceEnum/FindDeviceFactoryEnumList',
      data: {}
    }).then(res => {
      if(res.state === 1) {
        setDeviceFactory(res.data)
      }
    })
  }

  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [typeList, setTypeList] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const typeColumns = [
    {
      title: '设备样式',
      dataIndex: 'frontUrl',
      key: 'frontUrl',
      render: (frontUrl: any, record: any) => {
        return <Image
          src={record.frontUrl}
          style={{width: 60, height: 60}}
          fallback="data:image/png;base64,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"
        />
      }
    },
    {
      title: '型号编码',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: '设备类型',
      dataIndex: 'deviceTypeName',
      key: 'deviceTypeName',
    },
    {
      title: '设备型号',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '设备状态',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: any, record: any) => {
        return record.isActive ? <Tag color="green">启用</Tag> : <Tag color="red">禁用</Tag>
      }
    },
    {
      title: '型号设备数',
      dataIndex: 'modelDeviceNUms',
      key: 'modelDeviceNUms',
      width: 180
    },
    {
      title: '设备厂家',
      dataIndex: 'deviceFactory',
      key: 'deviceFactory',
      render: (deviceFactory: any, record: any) => {
        return (
          <>
            {deviceFactoryList && deviceFactoryList.map((item: {text: string, value: string}) => {
              return (
                item.value === record.deviceFactory ? item.text : ''
              )
            })}
          </>
        )
      }
    },
    {
      title: '操作',
      key: 'action',
      dataIndex: 'action',
      width: 180,
      fixed: 'right' as const,
      render: (action: any, record: any) => {
        return (
          <div>
            <Button color="primary" variant="link" size="small" onClick={() => handleTypeView(record)}>详情</Button>
            <Button color="cyan" variant="link" size="small" onClick={() => handleTypeEdit(record)}>编辑</Button>
            <>
              {
                record.isActive ?
                <Popconfirm
                  title="提示"
                  description="确定禁用型号?"
                  onConfirm={() => handleTypeDisabeld(record)}
                  okText="确定"
                  cancelText="取消">
                  <Button color="pink" variant="link" size="small">禁用</Button>
                </Popconfirm> :
                <Popconfirm
                  title="提示"
                  description="确定启用型号?"
                  onConfirm={() => handleTypeDisabeld(record)}
                  okText="确定"
                  cancelText="取消">
                  <Button color="green" variant="link" size="small">启用</Button>
                </Popconfirm>
              }
            </>
          </div>
        )
      }
    }
  ]

  const handleTypeView = (record: any) => {
    navigate(`/main/deviceType/detail`, { state: { model: record.modelId }});
    dispatch({
      type: 'PUSH_MENU_KEYPATH',
      payload: {
        selectedKeys: 'deviceTypeDetail',
        keyPath: '型号详情',
      }
    })
  }

  const handleTypeEdit = (record: any) => {
    navigate(`/main/deviceType/edit`, { state: { model: record.modelId }});
    dispatch({
      type: 'PUSH_MENU_KEYPATH',
      payload: {
        selectedKeys: 'deviceTypeEdit',
        keyPath: '编辑设备型号',
      }
    })
  }

  const handleTypeDisabeld = (record: any) => {
    Https.post({
      url: 'Api/device/V1/DeviceModel/DisableDeviceModel',
      data: {
        id: record.modelId
      }
    }).then(res => {
      if(res.state === 1) {
        messageApi.success('操作成功');
        getDeviceTypeList();
      } else {
        messageApi.error(res.errorMessage || res.data.errorMessage);
      }
    })
  }

  const deviceTypeChange = (value: string[]) => {
    setDeviceType(value);
  }

  const [toggleReset, setToggleReset] = useState(false);

  const reset = () => {
    setName('');
    setCode('');
    setPageIndex(1);
    setDeviceType([]);
    setToggleReset(true);
  }

  const search = () => {
    setPageIndex(1);
    getDeviceTypeList();
  }

  const getDeviceTypeList = () => {
    setLoading(true);
    Https.post({
      url: 'Api/device/V1/DeviceModel/List/By',
      data: {
        name,
        code,
        deviceType: deviceType.join(','),
        pageIndex,
        pageSize
      }
    }).then((res) => {
      if(res.state === 1) {
        setTypeList(res.data.deviceModels);
        setTotal(res.data.totalCount);
      } else {
        messageApi.error(res.data.errorMessage || res.errorMessage);
      }
    }).finally(() => {
      setLoading(false);
    });
  }

  const handleTypeCreate = () => {
    navigate(`/main/deviceType/create`);
    dispatch({
      type: 'PUSH_MENU_KEYPATH',
      payload: {
        selectedKeys: 'deviceTypeCreate',
        keyPath: '添加型号',
      }
    })
  }

  useEffect(() => {
    getDeviceTypeOptions();
    getDeviceFactoryList();
    getDeviceTypeList();
  }, [])

  useEffect(() => {
    getDeviceTypeList();
  }, [pageIndex, pageSize])

  useEffect(() => {
    if(toggleReset) {
      getDeviceTypeList();
      setToggleReset(false);
    }
  }, [toggleReset])

  return (
    <section className="Device-Type">
      <section className="search-box">
        <section className="search-item">
          <span className="search-label">型号名称</span>
          <Input placeholder="请输入型号名称" value={name} allowClear onChange={onNameChange} />
        </section>
        <section className="search-item">
          <span className="search-label">型号编码</span>
          <Input placeholder="请输入型号编码" value={code} allowClear onChange={onCodeChange} />
        </section>
        <section className="search-item">
          <span className="search-label">设备类型</span>
          <Cascader
            allowClear
            value={deviceType}
            options={deviceTypeOptions}
            onChange={(value) => deviceTypeChange(value as string[])}
            style={{ width: 200 }}
            placeholder="请选择设备类型"
          />
        </section>
      </section>
      <section className="search-btns">
        <Button onClick={reset}>重置</Button>
        <Button type="primary" onClick={search}>查询</Button>
        <Button type="primary" onClick={handleTypeCreate} icon={<PlusSquareOutlined />} style={{marginLeft: '10px'}}>添加型号</Button>
      </section>
      <section>
        <Table
          dataSource={typeList}
          rowKey="modelId"
          columns={typeColumns}
          pagination={false}
          scroll={{x: 'max-content', y: 'calc(100vh - 350px)'}}
          loading={loading}
         />
      </section>
      <section className="page-box">
        <Pagination
          align="end"
          current={pageIndex}
          total={total}
          defaultPageSize={10}
          defaultCurrent={1}
          showTotal={(total) => `共 ${total} 条`}
          onChange={(page, pageSize) => {
            setPageIndex(page);
            setPageSize(pageSize);
          }}
        />
      </section>
      { messageContextHolder }
    </section>
  )
}